
<ng-container>
  <div class="c-master-data-card-wrapper"
    [ngClass]="[isEditMode ? 'c-master-data-card-wrapper--is-deletable': '']">
    <div class="c-master-data-card-wrapper__checkbox" *ngIf="isSelectable">
      <mat-checkbox [appTheme]="'THEME_SYSTEM_SUCCESS'" color="primary"></mat-checkbox>
    </div>
    <div class="c-master-data-card-fields" (click)="itemClick()">
      <ng-container *ngFor="let name of cardProperties.slice(0,4)">
        <app-field-view
          [field]="name | findFieldByName : objectDefinition"
          [data]="item"
          [isInline]="true">
        </app-field-view>
      </ng-container>
    </div>
    <div class="c-master-data-card-wrapper__delete">
      <app-bui-button-icon *ngIf="isEditMode"
        [size]="'small'"
        [iconName]="'delete'"
        [comboStyle]="'naked-dark'"
        [borderStyle]="'light'"
        (clickEvent)="deleteItem()">
      </app-bui-button-icon>
    </div>
  </div>
</ng-container>

